import { IBatch } from '../types/batch';
import { createResultStat } from './result-stat';
import createTask from './task';

const createBatch = (res: any): IBatch => {
  const {
    desc,
    created_at,
    modified_at,
    fermented_at,
    scale_type,
    result_stat,
    image_volume,
    method_attributes,
    created_locally_at,
    user_correction_enabled,
    dilution_sample,
    dilution_sample_1,
    dilution_sample_2,
    dilution_stain,
    dilution_stain_1,
    dilution_stain_2,
    tasks,
    ...rest
  } = res;

  return {
    ...rest,
    description: desc,
    scaleType: scale_type,
    resultStat: createResultStat(result_stat),
    imageVolume: image_volume,
    createdAt: new Date(created_at),
    modifiedAt: modified_at ? new Date(modified_at) : null,
    fermentedAt: fermented_at ? new Date(fermented_at) : null,
    locallyCreatedAt: created_locally_at ? new Date(created_locally_at) : null,
    userCorrectionEnabled: user_correction_enabled,
    methodAttributes: {
      stain: parseInt(method_attributes.stain),
      analysisLevel: parseInt(method_attributes.analysis_level),
    },
    dilutionSample: dilution_sample,
    dilutionSample1: dilution_sample_1,
    dilutionSample2: dilution_sample_2,
    dilutionStain: dilution_stain,
    dilutionStain1: dilution_stain_1,
    dilutionStain2: dilution_stain_2,
    tasks: tasks.map((task: any) => createTask(task)),
  };
};

export default createBatch;
